var map = {
	"./Bootledesign.jpg": "1438",
	"./Bootledesign.png": "f881",
	"./Bootledesign_2020-04-23.zip": "52d5",
	"./CloseModel.svg": "6e36",
	"./CustomerLight.svg": "f623",
	"./DarkIcon/ChannelsHigh.svg": "169a",
	"./DarkIcon/Customer.svg": "7fea",
	"./DarkIcon/DashboardHigh.svg": "ddc1",
	"./DarkIcon/GSTHigh.svg": "0c4f",
	"./DarkIcon/InventoryHigh.svg": "5e1c",
	"./DarkIcon/OrderHigh.svg": "7656",
	"./DarkIcon/RemittancesHigh.svg": "cd1f",
	"./DarkIcon/ReportsHigh.svg": "a765",
	"./DarkIcon/ShipmentHigh.svg": "6305",
	"./DarkIcon/UserHigh.svg": "657b",
	"./DarkIcon/warehouseHigh.svg": "1152",
	"./Dashboard/cancelOrder.svg": "eb2c",
	"./Dashboard/itemSold.svg": "2f36",
	"./Dashboard/returnedOrder.svg": "6263",
	"./Dashboard/totalOrders.svg": "d3b8",
	"./Email_verify.svg": "6672",
	"./GST.svg": "c51f",
	"./Login/Call center-amico.svg": "bcab",
	"./Login/Invite-amico.svg": "744c",
	"./Login/loginLeft.svg": "f68f",
	"./Login/loginLeftBG.png": "72ca",
	"./Login/loginRight.svg": "eb61",
	"./Login/loginRightBG.png": "42be",
	"./Login/rightArrow.svg": "c708",
	"./Mask.svg": "a8c5",
	"./Phone_verify.svg": "7fb5",
	"./Profile/location.svg": "70df",
	"./Profile/mail.svg": "824a",
	"./Profile/phone.svg": "6691",
	"./Profile/profileEdit.svg": "d479",
	"./Profile/uploadPicture.svg": "b9be",
	"./SVG/404-Error-amico.svg": "8a69",
	"./SVG/Back.svg": "4c00",
	"./SVG/Group -1.svg": "3152",
	"./SVG/Group 2955.svg": "c3c6",
	"./SVG/Group-8796.svg": "c21c",
	"./SVG/Group-8797.svg": "5472",
	"./SVG/ShipmentHigh.svg": "753d",
	"./SVG/alias.svg": "9240",
	"./SVG/arrow-back.svg": "9153",
	"./SVG/check.svg": "0924",
	"./SVG/deleteRed.svg": "5df8",
	"./SVG/deleted.svg": "9f14",
	"./SVG/desktopFilter.svg": "13be",
	"./SVG/dimensions.svg": "0713",
	"./SVG/dotOrder.svg": "3d60",
	"./SVG/download.svg": "8c27",
	"./SVG/downloadDesk.svg": "0c95",
	"./SVG/downloadOrder.svg": "f55e",
	"./SVG/edit.svg": "38f3",
	"./SVG/filter-results-button.svg": "de37",
	"./SVG/invoice.svg": "d642",
	"./SVG/label.svg": "2b26",
	"./SVG/labelAndInvoice.svg": "2f4c",
	"./SVG/mapping.svg": "cfe6",
	"./SVG/menu.svg": "8df4",
	"./SVG/pdf.svg": "5172",
	"./SVG/placeholder.svg": "1a40",
	"./SVG/plusOrder.svg": "46aa",
	"./SVG/processingReport.svg": "ad71",
	"./SVG/rightOrder.svg": "cd9b",
	"./SVG/search.svg": "52bc",
	"./SVG/shareOrder.svg": "14f7",
	"./SVG/shipment.svg": "0bab",
	"./SVG/shipmentMobile.svg": "4d92",
	"./SVG/user.svg": "646a",
	"./Search.svg": "32f1",
	"./Vector_2.svg": "bea2",
	"./Warehouse.svg": "1d66",
	"./Welcome/4006.jpg": "2168",
	"./Welcome/adobeDesign.jpg": "ba68",
	"./Welcome/adobeTwo.jpg": "86da",
	"./Welcome/adobethree.jpg": "9f96",
	"./Welcome/begin-in-coffeeMug.jpg": "030e",
	"./Welcome/dashboard.png": "d480",
	"./Welcome/facebook.png": "b576",
	"./Welcome/image-1.jpg": "daa2",
	"./Welcome/image-2.jpg": "42ce",
	"./Welcome/image-3.jpg": "8681",
	"./Welcome/instagram.png": "15a3",
	"./Welcome/inventory-management.jpg": "493b",
	"./Welcome/inventory.png": "025d",
	"./Welcome/linkdin.png": "f12b",
	"./Welcome/network.png": "f0b4",
	"./Welcome/order-management.jpg": "b88d",
	"./Welcome/pay-fail.jpg": "d92d",
	"./Welcome/payment.png": "d68a",
	"./Welcome/return.png": "ef43",
	"./Welcome/sales.png": "6f03",
	"./Welcome/salesman.png": "380d",
	"./Welcome/twitter.png": "fa81",
	"./Welcome/up-arrows.png": "4f9d",
	"./Welcome/warehouse-management.jpg": "f783",
	"./Welcome/warehouse.jpg": "68e9",
	"./Welcome/white-walls.jpg": "7e0d",
	"./add.png": "d1da",
	"./add.svg": "eef4",
	"./alert-msg/Failure.svg": "b7da",
	"./alert-msg/Success.svg": "3500",
	"./alert-msg/close.svg": "9a17",
	"./alert-msg/error.svg": "9292",
	"./alert-msg/warning.svg": "aef4",
	"./amazon-card.svg": "629a",
	"./amazon-icon (2).svg": "0d9b",
	"./amazon-icon.png": "ae51",
	"./amazon-icon.svg": "8575",
	"./amazon_card.png": "99d0",
	"./back_arrow.svg": "73da",
	"./bag.jpg": "114c",
	"./bagImg.jpg": "1854",
	"./cancelCircle.svg": "ee94",
	"./channels.svg": "f07a",
	"./cloud-computing.svg": "d236",
	"./contact-us/leftBottomImg.svg": "1424",
	"./contact-us/location.svg": "bcf2",
	"./contact-us/mail.svg": "3481",
	"./contact-us/phone.svg": "a1d1",
	"./contact-us/rightTopImg.svg": "8dc4",
	"./dashboard.svg": "57a8",
	"./delete-red.svg": "63fd",
	"./delete.svg": "d739",
	"./delivery.svg": "d3e9",
	"./done.svg": "2e1f",
	"./download.svg": "6369",
	"./edit.svg": "6582",
	"./error-message/en": "80ca",
	"./error-message/en.js": "80ca",
	"./error-message/utils": "0481",
	"./error-message/utils.js": "0481",
	"./flipkaart.png": "16f6",
	"./flipkart (1) (1).svg": "755e",
	"./flipkart (1).png": "d5cb",
	"./flipkart.svg": "25e1",
	"./flipkartIcon.png": "0fb9",
	"./flipkartIcon.svg": "172a",
	"./fonts/AvenirNextLTPro-Bold.otf": "d0e8",
	"./fonts/AvenirNextLTPro-It.otf": "a739",
	"./fonts/AvenirNextLTPro-Regular.otf": "8696",
	"./fonts/BebasKai.otf": "13f3",
	"./fonts/Proxima Nova Bold.otf": "21ee",
	"./fonts/ProximaNova-Regular.otf": "97ba",
	"./fonts/Roboto-Bold.ttf": "3273",
	"./fonts/Roboto-Regular.ttf": "c524",
	"./fonts/quasimoda-light.otf": "bfe3",
	"./forgotPassword/Forgot password-amico.svg": "d4d6",
	"./forgotPassword/Intersection 3.png": "6eb4",
	"./forgotPassword/Intersection 3@2x.png": "5b1a",
	"./i18n": "d36b",
	"./i18n/": "d36b",
	"./i18n/en": "6a6a",
	"./i18n/en.json": "6a6a",
	"./i18n/index": "d36b",
	"./i18n/index.js": "d36b",
	"./info-icon.png": "f49b",
	"./inventory.svg": "e793",
	"./landing/SVG/Amazon Color.svg": "5a2a",
	"./landing/SVG/Amazon GS.svg": "4fb5",
	"./landing/SVG/Easy Return Color.svg": "129e",
	"./landing/SVG/Easy Return Line.svg": "c427",
	"./landing/SVG/Group 4110.svg": "a8fd",
	"./landing/SVG/Group 4165.svg": "0d30",
	"./landing/SVG/Group 4166.svg": "2a8a",
	"./landing/SVG/Group 4167.svg": "011f",
	"./landing/SVG/JioMart Color.svg": "23c6",
	"./landing/SVG/JioMart GS.svg": "0feb",
	"./landing/SVG/Landing.zip": "e0ab",
	"./landing/SVG/Login Line.svg": "ffc9",
	"./landing/SVG/Lower Man Power Color.svg": "851d",
	"./landing/SVG/Lower Man Power Line.svg": "aa13",
	"./landing/SVG/Mask Group 8.svg": "a5c9",
	"./landing/SVG/Request Demo Arrow (copy 1).svg": "36d6",
	"./landing/SVG/Request Demo Arrow-small.svg": "df89",
	"./landing/SVG/Request Demo Arrow.svg": "193e",
	"./landing/SVG/Sales Analysis Color.svg": "b07d",
	"./landing/SVG/Sales Analysis Line.svg": "cfd6",
	"./landing/SVG/Sales Color.svg": "6c3d",
	"./landing/SVG/Shiprocket Color.svg": "4729",
	"./landing/SVG/Shiprocket GS.svg": "10c7",
	"./landing/SVG/cashless-payment Color.svg": "cdc1",
	"./landing/SVG/cashless-payment line.svg": "9758",
	"./landing/SVG/enter.svg": "8edd",
	"./landing/SVG/facebook-fill.svg": "99f3",
	"./landing/SVG/flipkart Color.svg": "82fa",
	"./landing/SVG/flipkart GS.svg": "4def",
	"./landing/SVG/instagram-line.svg": "2122",
	"./landing/SVG/inventory Color.svg": "8139",
	"./landing/SVG/inventory Line.svg": "1b27",
	"./landing/SVG/linkedin-fill.svg": "e36b",
	"./landing/SVG/sales Line.svg": "613c",
	"./landing/pexels-cleyder-duque-3821384-com.jpg": "7080",
	"./landing/pexels-cleyder-duque-3821384.jpg": "b18a",
	"./landing/pexels-cleyder-duque-3821385-com.jpg": "f39f",
	"./landing/pexels-cleyder-duque-3821385.jpg": "d6ed",
	"./landing/pexels-negative-space-34577.jpg": "fce0",
	"./landing/pexels-photomix-company-106344-com.jpg": "5efa",
	"./landing/pexels-photomix-company-106344.jpg": "e13b",
	"./landing/pexels-pixabay-35550.jpg": "6c12",
	"./landing/pexels-pixabay-50987-com.jpg": "1c57",
	"./landing/pexels-pixabay-50987.jpg": "bcf2d",
	"./landing/pexels-tiger-lily-4483610-com.jpg": "8912",
	"./landing/pexels-tiger-lily-4483610.jpg": "ae09",
	"./lensinput.svg": "5968",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./mark-shipped.svg": "0313",
	"./minus.png": "5058",
	"./minusIcon.png": "4015",
	"./myntra-seeklogo.com.svg": "a782",
	"./myntra.png": "8939",
	"./myntra.svg": "7fd5",
	"./nav/HectoWhiteLogo.svg": "efc7",
	"./nav/HectocommerceLogo.svg": "0811",
	"./orders.svg": "961f",
	"./plus.png": "e359",
	"./plusIcon.png": "2335",
	"./plussss.png": "8654",
	"./refresh.png": "684f",
	"./remittances.svg": "e25a",
	"./report.svg": "5fdc",
	"./right.png": "5712",
	"./settings-blue.svg": "e183",
	"./settings.svg": "e9b0",
	"./shipment.svg": "5c74",
	"./transfer.svg": "1f3c",
	"./upload (1).svg": "20ff",
	"./upload.svg": "c118",
	"./uploadicon.svg": "fd2c",
	"./user.svg": "0f62",
	"./van.svg": "e5e7",
	"./verified-white.svg": "f94b",
	"./verified.svg": "0c49",
	"./view-more.svg": "bfb2",
	"./wallet.svg": "bc38",
	"./warehouse-High.svg": "0867",
	"./warehousee.svg": "2da8",
	"./wrong.png": "471b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";